module.exports = __webpack_public_path__ + "static/media/fred.b6f83cde.jpg";